import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import { fractionModelLogic } from './fraction_model.logic';
import { FractionModelActivityView } from './FractionModelViews';

export const fractionModelPlugin: ActivityPlugin<'fraction_model'> = {
  ...fractionModelLogic,
  displayName: GAME_MODE_CATALOG.fraction_model.displayName,
  icon: GAME_MODE_CATALOG.fraction_model.icon,
  HostView: FractionModelActivityView,
  StudentView: FractionModelActivityView,
  ProjectorView: FractionModelActivityView,
};

export { demoFractionModelPayload } from './fraction_model.logic';
